module.exports = __webpack_public_path__ + "static/media/Email03-Image.5aba1286.jpg";